"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverItemLink = exports.PopoverItemButton = exports.PopoverItem = exports.PopoverContent = exports.PopoverTrigger = exports.Popover = void 0;
const react_1 = __importStar(require("react"));
const react_popover_1 = require("@radix-ui/react-popover");
const Popover_styles_1 = require("./Popover.styles");
/**
 * @deprecated please use <Ds.Popover> instead
 */
const Popover = react_popover_1.Root;
exports.Popover = Popover;
/**
 * @deprecated please use <Ds.Popover> instead
 */
const PopoverTrigger = react_1.default.forwardRef(({ children, asChild = false }, forwardedRef) => {
    let childrenNodeType = ""; // Identify the type of child to render different output
    if (children === null || children === void 0 ? void 0 : children.type) {
        childrenNodeType =
            typeof children.type === "string"
                ? children.type
                : children.type.displayName;
    }
    if (asChild) {
        return (react_1.default.createElement(react_popover_1.Trigger, { asChild: true, ref: forwardedRef }, children));
    }
    switch (childrenNodeType) {
        case "button": // Html button
        case "styled.button": // Styled Component Html button
        case "Button": // Our react styled Button
            // Trigger renders a button we can't have a button inside a button. "asChild" will use the first children as trigger
            return (react_1.default.createElement(react_popover_1.Trigger, { asChild: true, ref: forwardedRef }, children));
        case "Icon":
            // StyledTrigger renders an unstyled button as a trigger, for accessibility, we want a rounded outline.
            return (react_1.default.createElement(Popover_styles_1.StyledTrigger, { radius: "50%", ref: forwardedRef }, children));
        case "a":
            console.error("Invalid HTML: <a> cannot appear as a child of <button> (PopoverTrigger)");
        default:
            // StyledTrigger renders an unstyled button as a trigger, for accessibility, we want a square outline.
            return (react_1.default.createElement(Popover_styles_1.StyledTrigger, { radius: "0", ref: forwardedRef }, children));
    }
});
exports.PopoverTrigger = PopoverTrigger;
/**
 * @deprecated please use <Ds.Popover> instead
 */
const PopoverContent = react_1.default.forwardRef((_a, forwardedRef) => {
    var _b;
    var { width } = _a, props = __rest(_a, ["width"]);
    return (react_1.default.createElement(react_popover_1.Portal, null,
        react_1.default.createElement(Popover_styles_1.StyledContent, Object.assign({ sideOffset: (_b = props.sideOffset) !== null && _b !== void 0 ? _b : 4, ref: forwardedRef, width: width }, props),
            react_1.default.createElement(Popover_styles_1.StyledUl, null, props.children))));
});
exports.PopoverContent = PopoverContent;
/**
 * @deprecated please use <Ds.Popover> instead
 */
const PopoverItem = (_a) => {
    var { children, active = false, onClick } = _a, props = __rest(_a, ["children", "active", "onClick"]);
    return (react_1.default.createElement(Popover_styles_1.StyledItem
    // This is used to ensure PopoverItems are focusable via a keyboard. Best practice would be to
    // use a PopoverItemButton or PopoverItemLink to achieve this. Leaving this in for backwards
    // compatability but will remove once use cases have been updated.
    , Object.assign({ 
        // This is used to ensure PopoverItems are focusable via a keyboard. Best practice would be to
        // use a PopoverItemButton or PopoverItemLink to achieve this. Leaving this in for backwards
        // compatability but will remove once use cases have been updated.
        tabIndex: onClick ? 0 : -1, active: active, onClick: onClick }, props), children));
};
exports.PopoverItem = PopoverItem;
/**
 * @deprecated please use <Ds.Popover> instead
 */
const PopoverItemButton = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { children, active = false, onClick } = _a, props = __rest(_a, ["children", "active", "onClick"]);
    return (react_1.default.createElement(Popover_styles_1.StyledBlockListItem, null,
        react_1.default.createElement(Popover_styles_1.StyledItemButton, Object.assign({ ref: forwardedRef, onClick: onClick, active: active }, props), children)));
});
exports.PopoverItemButton = PopoverItemButton;
/**
 * @deprecated please use <Ds.Popover> instead
 */
const PopoverItemLink = (_a) => {
    var { children, active = false, onClick } = _a, props = __rest(_a, ["children", "active", "onClick"]);
    return (react_1.default.createElement(Popover_styles_1.StyledBlockListItem, null,
        react_1.default.createElement(Popover_styles_1.StyledItemLink, Object.assign({ onClick: onClick, active: active }, props), children)));
};
exports.PopoverItemLink = PopoverItemLink;
//# sourceMappingURL=Popover.js.map